/* Maattabel (vervangt Kiwi Size Chart, 10 okt 2026). Zie snippets/mv-maattabel.liquid.
   Openen via de knop [data-mvm-open] of de "Maattabel"-link in de Kaching-balk (assets/theme.js). */
(function () {
  function rekenmachine(calc) {
    var data;
    try {
      data = JSON.parse(calc.querySelector('[data-mvm-data]').textContent);
    } catch (e) {
      console.error('[maattabel] rekenmachine-data onleesbaar', e);
      return;
    }
    var band = calc.querySelector('[data-mvm-band]');
    var cup = calc.querySelector('[data-mvm-cup]');
    var uitkomst = calc.querySelector('[data-mvm-uitkomst]');
    var perBand = {};
    data.banden.forEach(function (b) { perBand[b.waarde] = b; });

    band.addEventListener('change', function () {
      var b = perBand[band.value];
      uitkomst.textContent = '';
      if (!cup) {
        uitkomst.textContent = b ? b.maat : '';
        return;
      }
      cup.length = 1;
      cup.options[0].textContent = cup.dataset.leeg;
      (b ? b.cups : []).forEach(function (c) { cup.add(new Option(c[0], c[0])); });
    });

    if (cup) {
      cup.addEventListener('change', function () {
        var b = perBand[band.value];
        var gevonden = b && b.cups.filter(function (c) { return c[0] === cup.value; })[0];
        uitkomst.textContent = gevonden ? gevonden[1] : '';
      });
    }
  }

  function open(knop) {
    var dlg = document.getElementById(knop.getAttribute('aria-controls'));
    if (!dlg || dlg.open) return;
    dlg.showModal();
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-mvm-open]');
    if (knop) { open(knop); return; }
    var dlg = e.target.closest('dialog.mvm');
    if (!dlg) return;
    // klik op de achtergrond (buiten het venster) of op het kruisje sluit
    if (e.target === dlg || e.target.closest('[data-mvm-sluit]')) dlg.close();
  });

  document.querySelectorAll('[data-mvm-calc]').forEach(rekenmachine);
})();
